import { defineMessages } from 'react-intl';

export const displaySettingsMessages = defineMessages({
    displaySettings: {
        id: 'display-settings',
        defaultMessage: 'Display settings',
    },
    title: {
        id: 'title',
        defaultMessage: 'Title',
    },
    subtitle: {
        id: 'subtitle',
        defaultMessage: 'Subtitle',
    },
    titleColor: {
        id: 'title-color',
        defaultMessage: 'Title color',
    },
    subtitleColor: {
        id: 'subtitle-color',
        defaultMessage: 'Subtitle color',
    },
    successfulEntranceMessage: {
        id: 'successful-entrance-message',
        defaultMessage: 'Successfully entrance message',
    },
    rejectedEntranceMessage: {
        id: 'rejected-entrance-message',
        defaultMessage: 'Rejected entrance message',
    },
    successfulExitMessage: {
        id: 'successful-exit-message',
        defaultMessage: 'Successful exit message',
    },
    rejectedExitMessage: {
        id: 'rejected-exit-message',
        defaultMessage: 'Rejected exit message',
    },
    dateMessage: {
        id: 'date-message',
        defaultMessage: 'Date message',
    },
    spacesMessage: {
        id: 'spaces-message',
        defaultMessage: 'Spaces message',
    },
    lprMessage: {
        id: 'lpr-message',
        defaultMessage: 'LPR message',
    },
    ticketMessage: {
        id: 'ticket-message',
        defaultMessage: 'Ticket message',
    },
    cardMessage: {
        id: 'card-message',
        defaultMessage: 'Card message',
    },
    displaySettingsCreated: {
        id: 'display-settings-created',
        defaultMessage: 'Display settings created',
    },
    displaySettingsCreatedSuccess: {
        id: 'display-settings-created-success',
        defaultMessage: 'Display settings created successfully',
    },
    displaySettingsUpdated: {
        id: 'display-settings-updated',
        defaultMessage: 'Display settings updated',
    },
    displaySettingsUpdatedSuccess: {
        id: 'display-settings-updated-success',
        defaultMessage: 'Display settings updated successfully',
    },
});
